{
  "nav": "Tableaux de bord",
  "loading": "Chargement du tableau de bord…",
  "error": "Impossible de charger les tableaux de bord.",
  "retry": "Réessayer",
  "empty": {
    "title": "Aucun tableau de bord",
    "description": "Créez un tableau de bord, puis ajoutez-y des widgets.",
    "action": "Créer un tableau de bord"
  },
  "untitled": "Mon tableau de bord",
  "switcher": "Tableau de bord affiché",
  "new": "Nouveau",
  "newName": "Nouveau tableau de bord",
  "rename": "Renommer",
  "renameLabel": "Nom du tableau de bord",
  "delete": "Supprimer",
  "deleteConfirm": "Supprimer « {{name}} » et tous ses widgets ? Cette action est définitive.",
  "makeDefault": "Afficher à l’ouverture",
  "isDefault": "Affiché à l’ouverture",
  "edit": "Modifier",
  "done": "Terminer",
  "add": "Ajouter un widget",
  "undo": "Annuler",
  "undoHint": "Annuler la dernière modification (Ctrl+Z)",
  "saving": "Enregistrement…",
  "saved": "Enregistré",
  "saveFailed": "Échec de l’enregistrement — nouvel essai à la prochaine modification.",
  "removed": "Widget retiré.",
  "emptyGrid": "Ce tableau de bord est vide.",
  "emptyGridEdit": "Ajoutez un premier widget avec « Ajouter un widget ».",
  "readOnlyNarrow": "Écran étroit : modification désactivée.",
  "keyboardHelp": "Mode édition : Tab pour choisir un widget, flèches pour le déplacer, Maj+flèches pour le redimensionner, Entrée pour le configurer, Suppr pour le retirer.",
  "widget": {
    "configure": "Configurer {{name}}",
    "remove": "Retirer {{name}}",
    "move": "{{name}} — déplacer ou redimensionner au clavier",
    "moved": "{{name}} : colonne {{x}}, ligne {{y}}, {{w}} × {{h}}"
  },
  "catalog": {
    "title": "Ajouter un widget",
    "description": "Choisissez un type de widget, puis configurez-le.",
    "categories": {
      "metric": "Métriques",
      "event": "Événements",
      "spatial": "Cartes",
      "composite": "Composés",
      "ai": "IA",
      "action": "Actions"
    }
  },
  "editor": {
    "titleNew": "Nouveau widget : {{name}}",
    "titleEdit": "Configurer : {{name}}",
    "description": "Les modifications s’appliquent à l’enregistrement.",
    "save": "Enregistrer",
    "add": "Ajouter",
    "cancel": "Annuler",
    "invalid": "Complétez les champs requis.",
    "loading": "Chargement de l’éditeur…"
  }
}
